import { useRef } from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import {
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  Chip,
  Grid,
  Card,
  CircularProgress,
  FormControlLabel,
  Switch,
  Typography,
  Box,
  Button,
  TextField,
  Tooltip,
} from "@mui/material";
import mapicon from "../../../src/assets/images/mapIcon.png";
import { toast } from "react-toastify";
import { getDatabase, ref, onValue } from "firebase/database";
import { GoogleMap, useJsApiLoader, Marker, Polyline, InfoWindow, DirectionsRenderer } from "@react-google-maps/api";
import React, { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import BatteryStatusChip from "../../layouts/Escort/BatteryStatusChip";
import MDBox from "../../components/MDBox";
import UserConnected from "../../layouts/Escort/userConnected";
import Zone from "../../layouts/Escort/zone";
import Movement from "../../layouts/Escort/movement";
import UserFBK from "../../layouts/Escort/userFBK";
import LongMenu from "Utils/action";
import Timer from "Utils/Timer";
import movingFile from "../../Raw/moving.mp3";
import stoppedFile from "../../Raw/stopped.mp3";
import FBKfile from "../../Raw/fbk.mp3";
import "react-toastify/dist/ReactToastify.css";
import { getAddressFromCoordinates } from "Utils/helper";
import File from "Utils/file";
import VoiceDeterrencePlayer from "../../components/VoiceDeterrencePlayer";
import socketService from "../../socket/newsocketService";
import apiClient from "Utils/apiClient";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DirectionsCarRoundedIcon from "@mui/icons-material/DirectionsCarRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import NavigationRoundedIcon from "@mui/icons-material/NavigationRounded";
import RouteRoundedIcon from "@mui/icons-material/RouteRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import RecordVoiceOverRoundedIcon from "@mui/icons-material/RecordVoiceOverRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";

const getBatteryPercent = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.max(0, Math.min(100, numeric <= 1 ? numeric * 100 : numeric));
};

let nominatimCooldownUntil = 0;

const ShortDistanceEscort = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB249oWvDs5DTvKrtvDstCQ-IJC4uDpWkg",
  });
  const { id } = useParams();
  const location = useLocation();
  const passedState = location?.state || {};

  const movingFileAudio = useRef(new Audio(movingFile));
  const stoppedFileAudio = useRef(new Audio(stoppedFile));
  const FBKfileAudio = useRef(new Audio(FBKfile));
  movingFileAudio.current.loop = false;
  stoppedFileAudio.current.loop = false;

  const initialPassedLat = Number(
    passedState?.escort?.currentLat ??
    passedState?.escort?.LiveLatitude ??
    passedState?.escort?.lat ??
    passedState?.tripData?.currentLat ??
    passedState?.tripData?.LiveLatitude ??
    passedState?.tripData?.latitude
  );
  const initialPassedLng = Number(
    passedState?.escort?.currentLong ??
    passedState?.escort?.LiveLongitude ??
    passedState?.escort?.lng ??
    passedState?.tripData?.currentLong ??
    passedState?.tripData?.LiveLongitude ??
    passedState?.tripData?.longitude
  );
  const defaultCenter = !isNaN(initialPassedLat) && !isNaN(initialPassedLng) && initialPassedLat !== 0 && initialPassedLng !== 0
    ? { lat: initialPassedLat, lng: initialPassedLng }
    : { lat: 20.7675, lng: 72.9746 };

  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [initialMapCenter, setInitialMapCenter] = useState(null);
  const [userLocation, setUserLocation] = useState([]);
  const [markerList, setMarkerList] = useState([]);
  const [allData, setAllData] = useState(null);
  const [mongoUser, setMongoUser] = useState(null);
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [escortData, setEscortData] = useState({});
  const isLargeScreen = useMediaQuery("(min-width:1200px)");
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [customText, setCustomText] = useState("");

  // Route & Destination States
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [routeDistance, setRouteDistance] = useState("");
  const [routeDuration, setRouteDuration] = useState("");
  const [destinationCoords, setDestinationCoords] = useState(null);
  const [pickupCoords, setPickupCoords] = useState(null);
  const [destinationPlaceName, setDestinationPlaceName] = useState("");
  const [pickupPlaceName, setPickupPlaceName] = useState("");
  const [currentLivePlaceName, setCurrentLivePlaceName] = useState("");

  const handleSendCustomVoice = () => {
    if (!customText.trim()) return;

    // Send the voice deterrence socket event (handled by active screens)
    socketService.emit("custom_voice_deterrence", {
      userId: id,
      text: customText,
    });

    // ALSO send a push notification so the user receives it regardless of the screen
    socketService.emit("sendcustompushnotification", {
      userId: id,
      title: "Voice Message from Admin",
      message: customText,
      action: "admin_message",
    });

    toast.success("Voice message and notification sent to the driver");
    setCustomText("");
  };

  useEffect(() => {
    if (passedState?.tripData) {
      setEscortData((prev) => ({ ...(passedState.tripData || {}), ...(prev || {}) }));
    }
  }, [passedState?.tripData]);

  const processTripData = (data) => {
    if (!data) return;
    if (passedState?.tripData) {
      setEscortData((prev) => ({ ...(passedState.tripData || {}), ...(prev || {}) }));
    }
    const possibleTrips = data?.ShortDistance_Escort || data?.VirtualHomeCheck || data?.escortTrips || data?.escortData;
    if (possibleTrips && Object.values(possibleTrips).length > 0) {
      let tripArray = Object.values(possibleTrips);
      // Get the latest trip by sorting by timestamp
      tripArray.sort((a, b) => {
        const getMs = (val) => {
          const v = val?.currentTimeStamp || val?.tripendtime || val?.createdAt || 0;
          return typeof v === 'string' ? new Date(v).getTime() : v;
        };
        return getMs(b) - getMs(a);
      });
      var stops = tripArray[0];
      if (stops && stops.stopspoints) {
        setMarkerList(
          Object.values(stops.stopspoints).filter((d) => d.is_moving == false)
        );
      }
      setEscortData((prev) => ({ ...(prev || {}), ...stops }));
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await apiClient.get(`/users/${id}`);
        let userDetails = response?.data || {};
        if (userDetails.data) userDetails = userDetails.data;
        if (userDetails.data && !userDetails._id) userDetails = userDetails.data;
        
        setMongoUser(userDetails);
        setAllData(userDetails);
        processTripData(userDetails);

        // Fallback: If trip details are missing or empty, find trip in all-escorts-data
        if (!userDetails?.ShortDistance_Escort && !passedState?.tripData) {
          try {
            const allRes = await apiClient.get("/users/all-escorts-data", { params: { limit: 0 } });
            const { shortEscorts = [], cargoEscorts = [], virtualTravelGuards = [], virtualEscorts = [] } = allRes?.data || {};
            
            let matched = cargoEscorts.find((c) =>
              String(c._id) === String(id) ||
              String(c.userId) === String(id) ||
              String(c.userObjectKey) === String(id) ||
              String(c.DriverUserId) === String(id) ||
              String(c.loadId) === String(id) ||
              String(c.escortId) === String(id)
            );

            if (!matched) {
              matched = virtualTravelGuards.find((v) =>
                String(v._id) === String(id) ||
                String(v.userId) === String(id) ||
                String(v.payload?.userId) === String(id)
              );
            }

            if (!matched) {
              matched = virtualEscorts.find((v) =>
                String(v._id) === String(id) ||
                String(v.userId) === String(id) ||
                String(v.escortId) === String(id)
              );
            }

            if (!matched) {
              shortEscorts.forEach((u) => {
                const uId = u._id || u.id || u.userId;
                if (String(uId) === String(id)) {
                  const trips = Object.values(u.ShortDistance_Escort || u.escortTrips || {});
                  if (trips.length > 0) matched = trips[trips.length - 1];
                }
              });
            }

            if (matched) {
              setEscortData((prev) => ({ ...(matched || {}), ...(prev || {}) }));
              setAllData((prev) => ({ ...(matched || {}), ...(prev || {}) }));
            }
          } catch (escErr) {
            console.warn("Could not query all-escorts-data fallback:", escErr);
          }
        }
      } catch (err) {
        console.error("Failed to fetch user details", err);
      }
    };
    fetchUser();
  }, [id, passedState?.tripData]);

  useEffect(() => {
    if (!id) return;
    const db = getDatabase();
    const userRef = ref(db, `users/${id}`);
    const unsubscribe = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const fbData = snapshot.val();
        setFirebaseUser(fbData);
        // Merge Firebase live data into allData so all downstream consumers see it
        setAllData((prev) => ({ ...(prev || {}), ...fbData }));
      }
    });
    return () => unsubscribe?.();
  }, [id]);

  // Also listen on alternate key (such as mongoUser.key or uid) if it differs from URL id
  useEffect(() => {
    const altKey = mongoUser?.key || mongoUser?.uid;
    if (!altKey || altKey === id) return;
    const db = getDatabase();
    const userRef = ref(db, `users/${altKey}`);
    const unsubscribe = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const fbData = snapshot.val();
        setFirebaseUser(fbData);
        setAllData((prev) => ({ ...(prev || {}), ...fbData }));
      }
    });
    return () => unsubscribe?.();
  }, [mongoUser?.key, mongoUser?.uid, id]);

  // If this is a driver escort with a dedicated DriverUserId, subscribe to the driver's live Firebase updates
  useEffect(() => {
    const driverId =
      passedState?.tripData?.DriverUserId ||
      passedState?.escort?.tripData?.DriverUserId ||
      escortData?.DriverUserId ||
      escortData?.driverUserId;
    if (!driverId || driverId === id) return;
    const db = getDatabase();
    const driverRef = ref(db, `users/${driverId}`);
    const unsubscribe = onValue(driverRef, (snapshot) => {
      if (snapshot.exists()) {
        const fbData = snapshot.val();
        setFirebaseUser((prev) => ({ ...(prev || {}), ...fbData }));
        setAllData((prev) => ({ ...(prev || {}), ...fbData }));
      }
    });
    return () => unsubscribe?.();
  }, [id, passedState?.tripData?.DriverUserId, passedState?.escort?.tripData?.DriverUserId, escortData?.DriverUserId, escortData?.driverUserId]);

  // ── Socket Real-Time Location Updates ─────────────────────────────────────
  useEffect(() => {
    const handleLocationUpdate = (updatedUser) => {
      if (!updatedUser) return;
      // Use loose string comparison since MongoDB _id may be ObjectId while id is a string
      const matchId = String(updatedUser._id || "") === String(id) ||
                      String(updatedUser.userId || "") === String(id) ||
                      String(updatedUser.uid || "") === String(id) ||
                      String(updatedUser.key || "") === String(id);
      if (matchId) {
        setAllData((prev) => ({
          ...(prev || {}),
          ...updatedUser,
          online_status: true,
          currentTimeStamp: updatedUser?.currentTimeStamp || Date.now(),
        }));
        processTripData(updatedUser);
      }
    };

    const handleProfileUpdate = (profileData) => {
      if (!profileData) return;
      const matchId = String(profileData._id || "") === String(id) ||
                      String(profileData.userId || "") === String(id) ||
                      String(profileData.uid || "") === String(id) ||
                      String(profileData.key || "") === String(id);
      if (matchId) {
        setAllData((prev) => ({ ...(prev || {}), ...profileData }));
      }
    };

    socketService.on('userLocationUpdated', handleLocationUpdate);
    socketService.on('user_profile_updated', handleProfileUpdate);
    socketService.on('user_connection_change', handleProfileUpdate);
    return () => {
      socketService.off('userLocationUpdated', handleLocationUpdate);
      socketService.off('user_profile_updated', handleProfileUpdate);
      socketService.off('user_connection_change', handleProfileUpdate);
    };
  }, [id]);

  // ── Real-Time Escort Submissions (Videos / Audios / Saved Locations) ──────
  useEffect(() => {
    const handleEscortSubmission = (data) => {
      if (!data) return;
      const targetUid = String(data.userId || data.userObjectKey || data._id || "");
      const match = !targetUid ||
        targetUid === String(id) ||
        targetUid === String(mongoUser?._id || "") ||
        targetUid === String(mongoUser?.key || "");
      if (!match) return;

      const submission = data.submission || data.payload || data;
      if (submission) {
        setEscortData((prev) => {
          const currentVideos = Array.isArray(prev?.videos)
            ? [...prev.videos]
            : Object.values(prev?.videos || {});
          return {
            ...(prev || {}),
            videos: [...currentVideos, submission],
          };
        });
      }
    };

    socketService.on('uploadEscortVideo', handleEscortSubmission);

    const db = getDatabase();
    const videosRef = ref(db, `users/${id}/videos`);
    const unsubscribeVideos = onValue(videosRef, (snapshot) => {
      if (snapshot.exists()) {
        const val = snapshot.val();
        const list = Array.isArray(val) ? val : Object.values(val || {});
        if (list.length > 0) {
          setEscortData((prev) => {
            const existing = Array.isArray(prev?.videos)
              ? [...prev.videos]
              : Object.values(prev?.videos || {});
            const merged = [...existing];
            list.forEach((item) => {
              if (item && !merged.some((m) => m?.createdAt === item?.createdAt && m?.newCurrentLat === item?.newCurrentLat)) {
                merged.push(item);
              }
            });
            return {
              ...(prev || {}),
              videos: merged,
            };
          });
        }
      }
    });

    return () => {
      socketService.off('uploadEscortVideo', handleEscortSubmission);
      unsubscribeVideos?.();
    };
  }, [id, mongoUser]);

  const [mapRef, setMapRef] = useState(null);
  const displayData = {
    ...mongoUser,
    ...escortData,
    ...allData,
    ...(passedState?.tripData || {}),
    ...(passedState?.escort || {}),
    ...firebaseUser,
  };

  useEffect(() => {
    if (displayData) {
      const lat = firebaseUser?.LiveLatitude ?? firebaseUser?.currentLat ?? firebaseUser?.Latitude ??
                  allData?.LiveLatitude ?? allData?.currentLat ?? allData?.Latitude ??
                  mongoUser?.LiveLatitude ?? mongoUser?.currentLat ?? mongoUser?.Latitude ??
                  escortData?.LiveLatitude ?? escortData?.currentLat ?? escortData?.Latitude ??
                  passedState?.escort?.lat ?? passedState?.tripData?.latitude;
      const lng = firebaseUser?.LiveLongitude ?? firebaseUser?.currentLong ?? firebaseUser?.Longitude ??
                  allData?.LiveLongitude ?? allData?.currentLong ?? allData?.Longitude ??
                  mongoUser?.LiveLongitude ?? mongoUser?.currentLong ?? mongoUser?.Longitude ??
                  escortData?.LiveLongitude ?? escortData?.currentLong ?? escortData?.Longitude ??
                  passedState?.escort?.lng ?? passedState?.tripData?.longitude;

      if (lat !== undefined && lng !== undefined && !isNaN(Number(lat)) && !isNaN(Number(lng))) {
        const newCoord = { lat: Number(lat), lng: Number(lng) };
        setInitialMapCenter(prev => prev || newCoord);
        setMapCenter(newCoord);

        if (mapRef && !destinationCoords) {
          mapRef.panTo(newCoord);
        }

        setUserLocation((prev) => {
          const newLat = Number(lat);
          const newLng = Number(lng);
          // Only add if location is different from the last point to avoid duplicate points
          const lastPoint = prev[prev.length - 1];
          if (lastPoint) {
            if (lastPoint.lat === newLat && lastPoint.lng === newLng) {
              return prev;
            }
            // If the jump is larger than ~100km (1 degree), it's a jump from stale API data to live Firebase data (e.g., India to California).
            // Reset the path to avoid drawing a line across the ocean.
            if (Math.abs(lastPoint.lat - newLat) > 1 || Math.abs(lastPoint.lng - newLng) > 1) {
              return [{ lat: newLat, lng: newLng }];
            }
          }
          return [...prev, { lat: newLat, lng: newLng }];
        });
      }
    }
  }, [
    firebaseUser?.LiveLatitude,
    firebaseUser?.Latitude,
    firebaseUser?.currentLat,
    firebaseUser?.LiveLongitude,
    firebaseUser?.Longitude,
    firebaseUser?.currentLong,
    allData?.LiveLatitude,
    allData?.Latitude,
    allData?.currentLat,
    allData?.LiveLongitude,
    allData?.Longitude,
    allData?.currentLong,
    mongoUser?.currentLat,
    mongoUser?.LiveLatitude,
    mongoUser?.Latitude,
    mongoUser?.currentLong,
    mongoUser?.LiveLongitude,
    mongoUser?.Longitude,
    escortData?.LiveLatitude,
    escortData?.Latitude,
    escortData?.currentLat,
    escortData?.LiveLongitude,
    escortData?.Longitude,
    escortData?.currentLong,
    mapRef,
  ]);

  const COMPLETED_STATUSES = ["completed", "canceled", "cancelled", "ended", "rejected", "failed", "resolved"];

  const rawTripStatus = String(
    passedState?.status ||
    passedState?.tripStatus ||
    escortData?.Trip_Status ||
    escortData?.status ||
    allData?.Trip_Status ||
    allData?.status ||
    mongoUser?.Trip_Status ||
    mongoUser?.status ||
    (mongoUser?.escortInProgress === false ? "completed" : "") ||
    "active"
  ).trim().toLowerCase();

  const isTripActive = passedState?.isTripActive !== undefined
    ? Boolean(passedState.isTripActive)
    : !COMPLETED_STATUSES.includes(rawTripStatus) && mongoUser?.escortInProgress !== false;

  const speedVal = Number(
    firebaseUser?.LiveSpeed ?? firebaseUser?.CurrentSpeed ?? firebaseUser?.currentSpeed ?? firebaseUser?.speed ??
    allData?.LiveSpeed ?? allData?.CurrentSpeed ?? allData?.currentSpeed ?? allData?.speed ??
    mongoUser?.CurrentSpeed ?? mongoUser?.speed ??
    escortData?.LiveSpeed ?? escortData?.CurrentSpeed ?? escortData?.speed ??
    passedState?.tripData?.CurrentSpeed ?? passedState?.tripData?.speed ??
    0
  );

  const rawMovingVal = firebaseUser?.is_moving ?? firebaseUser?.IsMoving ?? firebaseUser?.isMoving ??
                         allData?.is_moving ?? allData?.IsMoving ?? allData?.isMoving ??
                         mongoUser?.is_moving ?? mongoUser?.IsMoving ??
                         escortData?.is_moving ?? escortData?.IsMoving ??
                         displayData?.is_moving ?? displayData?.IsMoving;

  const isMovingStatus =
    (rawMovingVal !== undefined && rawMovingVal !== null
      ? (rawMovingVal === true || String(rawMovingVal).toLowerCase() === "true" || rawMovingVal === 1 || rawMovingVal === "1")
      : false) || speedVal > 0;

  const prevMovingStatusRef = useRef(null);
  const movementDebounceTimerRef = useRef(null);

  const safePlayAudio = (audioRef) => {
    if (!audioRef?.current) return;
    try {
      audioRef.current.currentTime = 0;
      const playPromise = audioRef.current.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch((e) => {
          if (e.name !== "AbortError") console.warn(e);
        });
      }
    } catch {}
  };

  const safePauseAudio = (audioRef) => {
    if (!audioRef?.current) return;
    try {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    } catch {}
  };

  useEffect(() => {
    if (!isTripActive) {
      safePauseAudio(movingFileAudio);
      safePauseAudio(stoppedFileAudio);
      if (movementDebounceTimerRef.current) {
        clearTimeout(movementDebounceTimerRef.current);
        movementDebounceTimerRef.current = null;
      }
      return;
    }

    if (displayData?.userName) {
      // Avoid firing transition audio/toasts on first mount
      if (prevMovingStatusRef.current === null) {
        prevMovingStatusRef.current = isMovingStatus;
        return;
      }

      if (prevMovingStatusRef.current !== isMovingStatus) {
        if (movementDebounceTimerRef.current) {
          clearTimeout(movementDebounceTimerRef.current);
        }

        // Debounce for 1500ms to filter out momentary GPS jitter or rapid packet fluctuations
        movementDebounceTimerRef.current = setTimeout(() => {
          if (prevMovingStatusRef.current !== isMovingStatus) {
            prevMovingStatusRef.current = isMovingStatus;
            toast.dismiss("movement-status-toast");

            if (isMovingStatus) {
              safePauseAudio(stoppedFileAudio);
              safePlayAudio(movingFileAudio);
              toast.success(`${displayData?.userName} has started moving`, {
                toastId: "movement-status-toast",
              });
            } else {
              safePauseAudio(movingFileAudio);
              safePlayAudio(stoppedFileAudio);
              toast.error(`${displayData?.userName} has stopped moving`, {
                toastId: "movement-status-toast",
              });
            }
          }
        }, 1500);
      }
    }

    return () => {
      if (movementDebounceTimerRef.current) {
        clearTimeout(movementDebounceTimerRef.current);
      }
      safePauseAudio(movingFileAudio);
      safePauseAudio(stoppedFileAudio);
    };
  }, [isMovingStatus, displayData?.userName, isTripActive]);

  useEffect(() => {
    if (!isTripActive) return;

    FBKfileAudio.current.currentTime = 0;
    FBKfileAudio.current.loop = false;
    FBKfileAudio.current.pause();
    FBKfileAudio.current.play()?.catch((e) => console.warn(e));

    return () => {
      if (FBKfileAudio.current) {
        FBKfileAudio.current.currentTime = 0;
        FBKfileAudio.current.pause();
      }
    };
  }, [allData?.userFBK, isTripActive]);

  const handleMarkerClick = async (selectedMarker) => {
    const placeName = await getAddressFromCoordinates(selectedMarker.lat, selectedMarker.lng);

    setSelectedMarker({ ...selectedMarker, title: placeName });
  };

  const tripStatus = rawTripStatus || (isTripActive ? "In Progress" : "Completed");
  let safeUserFBK =
    passedState?.userFBK ??
    escortData?.userFBK ??
    allData?.userFBK ??
    firebaseUser?.userFBK ??
    mongoUser?.userFBK ??
    "";

  let safeWellbeing =
    passedState?.wellbeing ??
    escortData?.Wellbeing_Response ??
    escortData?.wellbeingResponse ??
    firebaseUser?.Wellbeing_Response ??
    firebaseUser?.wellbeingResponse ??
    allData?.Wellbeing_Response ??
    allData?.wellbeingResponse ??
    mongoUser?.Wellbeing_Response ??
    (isTripActive ? "Awaiting Response" : "Responded");

  if (!isTripActive) {
    if (safeWellbeing === "Awaiting Response") {
      safeWellbeing = safeUserFBK ? "Responded" : "Completed";
    }
  } else {
    if (safeUserFBK.toLowerCase() === "yes, we have arrived") {
      safeUserFBK = "No Feedback";
    }
  }

  const isUserResponded =
    safeWellbeing === "Responded" ||
    safeWellbeing === "Verified" ||
    (Boolean(safeUserFBK) &&
      safeUserFBK !== "No Feedback" &&
      safeUserFBK !== "null" &&
      safeUserFBK !== "undefined");

  const currentTripStartTime =
    Number(escortData?.currentTimeStamp) ||
    new Date(escortData?.createdAt || escortData?.tripStartTime || escortData?.startTime || 0).getTime() ||
    0;

  const rawArrivalTimestamp = Number(displayData?.arrivalpopuptimestamp) || 0;
  // If arrival popup timestamp is older than current trip start time, it's a stale leftover from a previous trip
  const isStaleArrivalTimestamp =
    currentTripStartTime > 0 && rawArrivalTimestamp > 0 && rawArrivalTimestamp < currentTripStartTime;
  const isArrivalPending = Boolean(displayData?.arrivalpopup) && !isStaleArrivalTimestamp;
  const isUnresponsiveActive = isTripActive && !isUserResponded && isArrivalPending && rawArrivalTimestamp > 0;

  // Derive trip pickup & destination addresses
  const pickupText =
    passedState?.pickupLocation ||
    passedState?.escort?.pickupLocation ||
    passedState?.escort?.tripData?.pickupLocation ||
    passedState?.tripData?.pickupLocation ||
    escortData?.pickupLocation ||
    escortData?.PickupLocation ||
    escortData?.currentLocTxt ||
    escortData?.Place ||
    escortData?.currentLoc ||
    escortData?.address ||
    escortData?.landmark ||
    escortData?.startLocation ||
    displayData?.pickupLocation ||
    displayData?.currentLocTxt ||
    displayData?.address ||
    allData?.pickupLocation ||
    allData?.currentLocTxt ||
    mongoUser?.pickupLocation ||
    mongoUser?.currentLocTxt ||
    "";

  const destinationText =
    passedState?.deliveryLocation ||
    passedState?.escort?.deliveryLocation ||
    passedState?.escort?.tripData?.deliveryLocation ||
    passedState?.tripData?.deliveryLocation ||
    escortData?.deliveryLocation ||
    escortData?.DeliveryLocation ||
    escortData?.destLocTxt ||
    escortData?.destLoc ||
    escortData?.destination ||
    escortData?.Destination ||
    escortData?.destLocation ||
    escortData?.ArrivalStation ||
    escortData?.endLocation ||
    escortData?.to ||
    displayData?.deliveryLocation ||
    displayData?.destLocTxt ||
    displayData?.destination ||
    allData?.deliveryLocation ||
    allData?.destLocTxt ||
    mongoUser?.deliveryLocation ||
    mongoUser?.destLocTxt ||
    "";

  const stateName =
    passedState?.escort?.state ||
    escortData?.state ||
    displayData?.state ||
    mongoUser?.state ||
    allData?.state ||
    "";

  // Derive driver, requester, vehicle & escort type
  const driverName =
    escortData?.DriverName ||
    escortData?.driverName ||
    displayData?.DriverName ||
    displayData?.driverName ||
    (passedState?.escort?.type === "Driver Escort" ? (displayData?.userName || passedState?.escort?.name) : "") ||
    "";

  const driverPhone =
    escortData?.DriverPhoneNo ||
    escortData?.driverPhone ||
    escortData?.driverPhoneNo ||
    displayData?.DriverPhoneNo ||
    displayData?.driverPhone ||
    (passedState?.escort?.type === "Driver Escort" ? (displayData?.userPhone || passedState?.escort?.phone) : "") ||
    "";

  const requesterName =
    escortData?.RequesterName ||
    escortData?.requesterName ||
    displayData?.RequesterName ||
    displayData?.userName ||
    passedState?.escort?.name ||
    "Unknown User";

  const requesterPhone =
    escortData?.RequesterPhoneNo ||
    escortData?.requesterPhone ||
    displayData?.RequesterPhoneNo ||
    displayData?.userPhone ||
    passedState?.escort?.phone ||
    "N/A";

  const vehiclePlate =
    escortData?.vehicleNumber ||
    escortData?.VehicleNumber ||
    escortData?.VhiclePlate ||
    escortData?.vehicleReg ||
    displayData?.vehicleNumber ||
    displayData?.VehicleNumber ||
    displayData?.vehicleReg ||
    "N/A";

  const escortTypeLabel =
    passedState?.escort?.type ||
    passedState?.escort?.requestType ||
    (driverName || escortData?.DriverUserId ? "Driver Escort" : escortData?.cargoType ? "Cargo Escort" : "User Escort");

  const escortIdDisplay =
    passedState?.escort?.escortId ||
    escortData?.escortId ||
    `ESC-${String(id || "1000").substring(0, 4).toUpperCase()}`;

  // 1. Geocode destination with Google & OpenStreetMap fallback
  useEffect(() => {
    if (!destinationText) return;

    // Check direct coordinates in data
    const destLat = Number(
      passedState?.escort?.destLat ??
      passedState?.tripData?.destinationLat ??
      passedState?.tripData?.destLat ??
      passedState?.tripData?.deliveryLat ??
      escortData?.destinationLat ??
      escortData?.destLat ??
      escortData?.deliveryLat ??
      firebaseUser?.destinationLat ??
      firebaseUser?.destLat ??
      mongoUser?.destinationLat ??
      mongoUser?.destLat ??
      displayData?.destinationLat ??
      displayData?.destLat
    );
    const destLng = Number(
      passedState?.escort?.destLng ??
      passedState?.tripData?.destinationLong ??
      passedState?.tripData?.destLng ??
      passedState?.tripData?.deliveryLng ??
      escortData?.destinationLong ??
      escortData?.destLng ??
      escortData?.deliveryLng ??
      firebaseUser?.destinationLong ??
      firebaseUser?.destLng ??
      mongoUser?.destinationLong ??
      mongoUser?.destLng ??
      displayData?.destinationLong ??
      displayData?.destLng
    );
    if (!isNaN(destLat) && !isNaN(destLng) && destLat !== 0 && destLng !== 0) {
      setDestinationCoords({ lat: destLat, lng: destLng });
      setDestinationPlaceName(destinationText);
      return;
    }

    let isResolved = false;

    const fallbackGeocode = (addr) => {
      if (isResolved || !addr) return;

      const cacheKey = `dest_coord_${addr.substring(0, 45).replace(/\s+/g, "_")}`;
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
        if (cached?.lat && cached?.lng) {
          isResolved = true;
          setDestinationCoords(cached);
          setDestinationPlaceName(destinationText);
          return;
        }
      } catch {}

      // Clean noise prefixes/words from segments
      const cleanSegment = (s) =>
        s
          .replace(/^(temple|behind|near|opp|opposite|b\/h|b\/d|flat|plot|house|shop|room|floor|b\d+|a\d+|c\d+|d\d+)\s*,?\s*/i, "")
          .replace(/\b(behind|near|opposite|opp|b\/h)\b/gi, "")
          .trim();

      const rawParts = addr.split(",").map((p) => p.trim()).filter(Boolean);
      // City is usually 2nd or 3rd from end
      const cityCandidate = rawParts.length >= 3 ? rawParts[rawParts.length - 3] : (rawParts[rawParts.length - 2] || "");
      const cleanCity = cityCandidate.replace(/\d+/g, "").trim();

      const queries = [];
      // 1. Full raw address
      queries.push(addr);

      // 2. Specific landmark keywords combined with city (e.g. "Somnath Bilimora", "Deep Laxmi Bilimora")
      rawParts.forEach((part) => {
        const cleaned = cleanSegment(part);
        if (
          cleaned &&
          cleaned.length >= 4 &&
          !/^\d+$/.test(cleaned) &&
          cleaned.toLowerCase() !== "india" &&
          cleaned.toLowerCase() !== cleanCity.toLowerCase()
        ) {
          if (cleanCity) {
            queries.push(`${cleaned} ${cleanCity}`);
          }
          queries.push(cleaned);
        }
      });

      // 3. Extract meaningful individual keywords (e.g. "Somnath", "Temple") paired with city
      const words = addr.split(/[\s,]+/).filter((w) => w.length > 3 && !/^(behind|near|opposite|gujarat|india|\d+)$/i.test(w));
      for (const w of words) {
        if (cleanCity && w.toLowerCase() !== cleanCity.toLowerCase()) {
          queries.push(`${w} ${cleanCity}`);
        }
      }

      // 4. Sub-slices of the address
      queries.push(addr.replace(/^[a-zA-Z0-9\s]+,\s*/, ""));
      queries.push(rawParts.slice(-3).join(", "));
      queries.push(rawParts.slice(-2).join(", "));

      const uniqueQueries = [...new Set(queries.filter((q) => q && q.length >= 3))];

      if (uniqueQueries.length > 0 && Date.now() >= nominatimCooldownUntil) {
        (async () => {
          try {
            const q = uniqueQueries[0];
            const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&format=json&limit=1`, {
              headers: { "Accept-Language": "en" },
            });
            if (res.status === 429) {
              nominatimCooldownUntil = Date.now() + 60000;
              return;
            }
            const data = await res.json();
            if (Array.isArray(data) && data.length > 0 && data[0].lat && data[0].lon) {
              isResolved = true;
              const coords = { lat: Number(data[0].lat), lng: Number(data[0].lon) };
              setDestinationCoords(coords);
              setDestinationPlaceName(data[0].display_name || destinationText);
              try {
                sessionStorage.setItem(cacheKey, JSON.stringify(coords));
              } catch {}
            }
          } catch {}
        })();
      }
    };

    // Attempt 1: Google Geocoder if loaded
    if (isLoaded && window.google?.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: destinationText }, (results, status) => {
        if (status === "OK" && results?.[0]?.geometry?.location) {
          isResolved = true;
          const loc = results[0].geometry.location;
          setDestinationCoords({ lat: loc.lat(), lng: loc.lng() });
          setDestinationPlaceName(results[0].formatted_address || destinationText);
        } else {
          // If Google fails (e.g. OVER_QUERY_LIMIT or no billing), fallback to OpenStreetMap
          fallbackGeocode(destinationText);
        }
      });
    } else {
      fallbackGeocode(destinationText);
    }
  }, [
    isLoaded,
    destinationText,
    passedState?.escort?.destLat,
    passedState?.tripData?.destinationLat,
    escortData?.destinationLat,
    escortData?.destLat,
    escortData?.destinationLong,
    escortData?.destLng,
    firebaseUser?.destinationLat,
    firebaseUser?.destLat,
    firebaseUser?.destinationLong,
    firebaseUser?.destLng,
    mongoUser?.destinationLat,
    mongoUser?.destLat,
  ]);

  // 2. Reverse geocode live current location (mapCenter) with 2.5s debounce & 429 cooldown protection
  useEffect(() => {
    if (!mapCenter?.lat || !mapCenter?.lng || isNaN(mapCenter.lat) || isNaN(mapCenter.lng)) return;
    const roundedLat = Number(mapCenter.lat).toFixed(3);
    const roundedLng = Number(mapCenter.lng).toFixed(3);
    const cacheKey = `live_loc_${roundedLat}_${roundedLng}`;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      setCurrentLivePlaceName(cached);
      return;
    }

    const timer = setTimeout(() => {
      if (isLoaded && window.google?.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: mapCenter }, (results, status) => {
          if (status === "OK" && results?.[0]?.formatted_address) {
            const clean = results[0].formatted_address.replace(/,\s*India$/i, "").trim();
            sessionStorage.setItem(cacheKey, clean);
            setCurrentLivePlaceName(clean);
            return;
          }
          // Fallback to OpenStreetMap if not on cooldown
          if (Date.now() < nominatimCooldownUntil) {
            const fallbackStr = `Location (${Number(mapCenter.lat).toFixed(4)}, ${Number(mapCenter.lng).toFixed(4)})`;
            sessionStorage.setItem(cacheKey, fallbackStr);
            setCurrentLivePlaceName(fallbackStr);
            return;
          }
          fetch(`https://nominatim.openstreetmap.org/reverse?lat=${mapCenter.lat}&lon=${mapCenter.lng}&format=json`, {
            headers: { "Accept-Language": "en" },
          })
            .then((r) => {
              if (r.status === 429) {
                nominatimCooldownUntil = Date.now() + 60000;
                throw new Error("429");
              }
              return r.json();
            })
            .then((d) => {
              if (d?.display_name) {
                const clean = d.display_name.replace(/,\s*India$/i, "").trim();
                sessionStorage.setItem(cacheKey, clean);
                setCurrentLivePlaceName(clean);
              }
            })
            .catch(() => {
              const fallbackStr = `Location (${Number(mapCenter.lat).toFixed(4)}, ${Number(mapCenter.lng).toFixed(4)})`;
              sessionStorage.setItem(cacheKey, fallbackStr);
              setCurrentLivePlaceName(fallbackStr);
            });
        });
      } else {
        if (Date.now() < nominatimCooldownUntil) {
          const fallbackStr = `Location (${Number(mapCenter.lat).toFixed(4)}, ${Number(mapCenter.lng).toFixed(4)})`;
          sessionStorage.setItem(cacheKey, fallbackStr);
          setCurrentLivePlaceName(fallbackStr);
          return;
        }
        fetch(`https://nominatim.openstreetmap.org/reverse?lat=${mapCenter.lat}&lon=${mapCenter.lng}&format=json`, {
          headers: { "Accept-Language": "en" },
        })
          .then((r) => {
            if (r.status === 429) {
              nominatimCooldownUntil = Date.now() + 60000;
              throw new Error("429");
            }
            return r.json();
          })
          .then((d) => {
            if (d?.display_name) {
              const clean = d.display_name.replace(/,\s*India$/i, "").trim();
              sessionStorage.setItem(cacheKey, clean);
              setCurrentLivePlaceName(clean);
            }
          })
          .catch(() => {
            const fallbackStr = `Location (${Number(mapCenter.lat).toFixed(4)}, ${Number(mapCenter.lng).toFixed(4)})`;
            sessionStorage.setItem(cacheKey, fallbackStr);
            setCurrentLivePlaceName(fallbackStr);
          });
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [isLoaded, mapCenter?.lat, mapCenter?.lng]);

  // 3. Geocode pickup point if explicitly provided
  useEffect(() => {
    if (!pickupText || pickupText.toLowerCase() === "current location") return;
    const pLat = Number(escortData?.pickupLat ?? escortData?.startLat);
    const pLng = Number(escortData?.pickupLong ?? escortData?.pickupLng ?? escortData?.startLng);
    if (!isNaN(pLat) && !isNaN(pLng) && pLat !== 0 && pLng !== 0) {
      setPickupCoords({ lat: pLat, lng: pLng });
      setPickupPlaceName(pickupText);
      return;
    }

    if (isLoaded && window.google?.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: pickupText }, (results, status) => {
        if (status === "OK" && results?.[0]?.geometry?.location) {
          const loc = results[0].geometry.location;
          setPickupCoords({ lat: loc.lat(), lng: loc.lng() });
          setPickupPlaceName(results[0].formatted_address || pickupText);
        }
      });
    }
  }, [isLoaded, pickupText, escortData?.pickupLat, escortData?.startLat]);

  // 4. Request driving directions between mapCenter and destinationCoords
  useEffect(() => {
    if (!isLoaded || !window.google?.maps || !mapCenter?.lat || !destinationCoords?.lat) return;

    const directionsService = new window.google.maps.DirectionsService();
    const originTarget = new window.google.maps.LatLng(mapCenter.lat, mapCenter.lng);
    const destTarget = new window.google.maps.LatLng(destinationCoords.lat, destinationCoords.lng);

    directionsService.route(
      {
        origin: originTarget,
        destination: destTarget,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK" && result?.routes?.[0]?.legs?.[0]) {
          setDirectionsResponse(result);
          const leg = result.routes[0].legs[0];
          setRouteDistance(leg.distance?.text || "");
          setRouteDuration(leg.duration?.text || "");
        }
      }
    );
  }, [isLoaded, mapCenter?.lat, mapCenter?.lng, destinationCoords?.lat, destinationCoords?.lng]);

  // 5. Auto-fit map bounds so both Current Location and Destination are visible together
  useEffect(() => {
    if (!mapRef || !window.google?.maps) return;
    if (mapCenter?.lat && destinationCoords?.lat) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(mapCenter.lat, mapCenter.lng));
      bounds.extend(new window.google.maps.LatLng(destinationCoords.lat, destinationCoords.lng));
      mapRef.fitBounds(bounds, 80);
    }
  }, [mapRef, mapCenter?.lat, mapCenter?.lng, destinationCoords?.lat, destinationCoords?.lng]);

  const mapStyles = { height: isLargeScreen ? "550px" : "400px", width: "100%" };
  if (!isLoaded) {
    return (
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}
      >
        <h1>Loading the map...</h1>
      </div>
    );
  }
  return (
    <>
      <DashboardLayout>
        <VoiceDeterrencePlayer escortType="driver-escort" audience="driver" />
        <MDBox mt={3} pb={4} sx={{ px: { xs: 1, sm: 2 } }}>
          {/* ── 1. Escort Executive Header Banner ── */}
          <Card
            sx={{
              p: 2.5,
              mb: 3,
              bgcolor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              boxShadow: "0 2px 12px rgba(15, 23, 42, 0.04)",
            }}
          >
            {/* Top row: Back button & Escort Type / Status Badges */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1.5,
                pb: 2,
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <Button
                variant="outlined"
                size="small"
                startIcon={<ArrowBackRoundedIcon />}
                onClick={() => window.history.back()}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.82rem",
                  color: "#334155",
                  borderColor: "#cbd5e1",
                  px: 1.8,
                  py: 0.6,
                  bgcolor: "#fff",
                  "&:hover": { bgcolor: "#f8fafc", borderColor: "#94a3b8" },
                }}
              >
                Back to Escorts
              </Button>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Chip
                  label={escortTypeLabel}
                  size="small"
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.75rem",
                    bgcolor:
                      escortTypeLabel === "Driver Escort"
                        ? "#e0f2fe"
                        : escortTypeLabel === "Cargo Escort"
                        ? "#fef3c7"
                        : "#f1f5f9",
                    color:
                      escortTypeLabel === "Driver Escort"
                        ? "#0369a1"
                        : escortTypeLabel === "Cargo Escort"
                        ? "#b45309"
                        : "#475569",
                    border: `1px solid ${
                      escortTypeLabel === "Driver Escort"
                        ? "#bae6fd"
                        : escortTypeLabel === "Cargo Escort"
                        ? "#fde68a"
                        : "#e2e8f0"
                    }`,
                  }}
                />
                <Chip
                  label={isTripActive ? "Active Trip" : "Trip Completed"}
                  size="small"
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.75rem",
                    bgcolor: isTripActive ? "#dcfce7" : "#f1f5f9",
                    color: isTripActive ? "#15803d" : "#64748b",
                    border: `1px solid ${isTripActive ? "#bbf7d0" : "#e2e8f0"}`,
                  }}
                />
                {escortData?.loadId && (
                  <Chip
                    label={`Load ID: ${escortData.loadId}`}
                    size="small"
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.75rem",
                      fontFamily: "monospace",
                      bgcolor: "#f8fafc",
                      color: "#334155",
                      border: "1px solid #cbd5e1",
                    }}
                  />
                )}
              </Box>
            </Box>

            {/* Main Title & Key Info Pills */}
            <Box
              sx={{
                pt: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box>
                <Typography variant="h5" fontWeight="800" sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>
                  {escortTypeLabel} Live Tracking
                </Typography>
                <Typography variant="body2" sx={{ color: "#64748b", mt: 0.3 }}>
                  Real-time telematics, route telemetry, and driver deterrence system
                </Typography>
              </Box>

              {/* Horizontal Pill Badges */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, flexWrap: "wrap" }}>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.8,
                    px: 1.4,
                    py: 0.7,
                    bgcolor: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                  }}
                >
                  <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                    Escort ID:
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 800, color: "#0f172a", fontFamily: "monospace" }}>
                    {escortIdDisplay}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.8,
                    px: 1.4,
                    py: 0.7,
                    bgcolor: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                  }}
                >
                  <DirectionsCarRoundedIcon sx={{ fontSize: "1.1rem", color: "#64748b" }} />
                  <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                    Vehicle:
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 800, color: "#0f172a", fontFamily: "monospace" }}>
                    {vehiclePlate}
                  </Typography>
                </Box>

                {stateName && stateName !== "Unknown" && (
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.8,
                      px: 1.4,
                      py: 0.7,
                      bgcolor: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                    }}
                  >
                    <PlaceRoundedIcon sx={{ fontSize: "1.1rem", color: "#64748b" }} />
                    <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                      State:
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 800, color: "#0f172a" }}>
                      {stateName}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Card>

          {/* ── 2. Information Cards Grid (Equal 3-column layout) ── */}
          <Grid container spacing={2.5} sx={{ mb: 3 }}>
            {/* Card 1: Driver & User Profile */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  p: 2.5,
                  bgcolor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "16px",
                  boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography variant="subtitle2" fontWeight="700" sx={{ color: "#475569", mb: 1.5, textTransform: "uppercase", fontSize: "0.72rem", letterSpacing: "0.06em" }}>
                    Driver & Contact Profile
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1.5 }}>
                    <Avatar
                      src={displayData?.userImage || escortData?.DriverImage}
                      alt={driverName || displayData?.userName}
                      sx={{ width: 62, height: 62, border: "2px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography variant="h6" fontWeight="bold" sx={{ color: "#0f172a", lineHeight: 1.2 }}>
                        {driverName || requesterName || displayData?.userName || "Unknown User"}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mt: 0.4 }}>
                        <PhoneRoundedIcon sx={{ fontSize: "0.95rem", color: "#0284c7" }} />
                        <Typography
                          component="a"
                          href={`tel:${driverPhone || requesterPhone || displayData?.userPhone}`}
                          variant="body2"
                          sx={{ color: "#0284c7", fontWeight: 600, textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                        >
                          {driverPhone || requesterPhone || displayData?.userPhone || "No Phone"}
                        </Typography>
                      </Box>
                      {driverName && requesterName && driverName !== requesterName && (
                        <Typography variant="caption" sx={{ color: "#64748b", display: "block", mt: 0.4, fontWeight: 500 }}>
                          Requester: <strong>{requesterName}</strong> {requesterPhone ? `(${requesterPhone})` : ""}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Box sx={{ my: 1.5, borderBottom: "1px solid #f1f5f9" }} />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Battery Health</Typography>
                      <MDBox mt={0.5}>
                        <BatteryStatusChip status={getBatteryPercent(firebaseUser?.BatteryIndicator ?? firebaseUser?.batteryLevel ?? displayData?.BatteryIndicator ?? escortData?.BatteryIndicator ?? 0).toFixed(2)} />
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Connection</Typography>
                      <MDBox mt={0.5}>
                        <UserConnected user={displayData} userId={id} isTripActive={isTripActive} />
                      </MDBox>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </Grid>

            {/* Card 2: Status & Telemetry Indicators */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  p: 2.5,
                  bgcolor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "16px",
                  boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography variant="subtitle2" fontWeight="700" sx={{ color: "#475569", mb: 1.5, textTransform: "uppercase", fontSize: "0.72rem", letterSpacing: "0.06em" }}>
                    Telemetry & Live Feedback
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Movement Mode</Typography>
                      <MDBox mt={0.5}>
                        <Movement user={displayData} isTripActive={isTripActive} />
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Zone Fencing</Typography>
                      <MDBox mt={0.5}>
                        <Zone status={escortData?.zone_fenceing} />
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>User Feedback</Typography>
                      <MDBox mt={0.5}>
                        <UserFBK status={safeUserFBK} />
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Wellbeing Check</Typography>
                      <MDBox mt={0.5}>
                        <Chip
                          label={safeWellbeing || "N/A"}
                          size="small"
                          sx={{
                            fontWeight: "bold",
                            bgcolor:
                              safeWellbeing === "Responded" || safeWellbeing === "Verified"
                                ? "#dcfce7"
                                : safeWellbeing === "Danger"
                                ? "#fee2e2"
                                : "#f1f5f9",
                            color:
                              safeWellbeing === "Responded" || safeWellbeing === "Verified"
                                ? "#15803d"
                                : safeWellbeing === "Danger"
                                ? "#b91c1c"
                                : "#475569",
                            border: `1px solid ${
                              safeWellbeing === "Responded" || safeWellbeing === "Verified"
                                ? "#bbf7d0"
                                : safeWellbeing === "Danger"
                                ? "#fecaca"
                                : "#e2e8f0"
                            }`,
                          }}
                        />
                      </MDBox>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </Grid>

            {/* Card 3: Vehicle Details & Emergency Actions */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  p: 2.5,
                  bgcolor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "16px",
                  boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography variant="subtitle2" fontWeight="700" sx={{ color: "#475569", mb: 1.5, textTransform: "uppercase", fontSize: "0.72rem", letterSpacing: "0.06em" }}>
                    Vehicle & Security Response
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                    <Avatar
                      src={escortData?.imgVehicle || escortData?.WellBeingTripPic || escortData?.evidenceFile}
                      alt={escortData?.imgVehicle || "Vehicle"}
                      variant="rounded"
                      sx={{ width: 56, height: 56, border: "1px solid #e2e8f0" }}
                    />
                    <Box>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Plate Registration</Typography>
                      <Box
                        sx={{
                          display: "inline-block",
                          px: 1.2,
                          py: 0.3,
                          bgcolor: "#f1f5f9",
                          borderRadius: "6px",
                          border: "1px solid #cbd5e1",
                          fontFamily: "monospace",
                          fontWeight: 800,
                          fontSize: "0.95rem",
                          color: "#0f172a",
                          mt: 0.3,
                        }}
                      >
                        {vehiclePlate}
                      </Box>
                      {escortData?.cargoType && (
                        <Typography variant="caption" sx={{ color: "#d97706", display: "block", fontWeight: 700, mt: 0.3 }}>
                          Cargo: {escortData.cargoType} {escortData?.cargoValue ? `(₦${escortData.cargoValue})` : ""}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Box sx={{ my: 1.5, borderBottom: "1px solid #f1f5f9" }} />
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Unresponsive Timer</Typography>
                      <MDBox mt={0.5}>
                        {!isTripActive ? (
                          <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 600 }}>
                            Trip Ended
                          </Typography>
                        ) : isUserResponded ? (
                          <Typography variant="body2" sx={{ color: "#16a34a", fontWeight: 700 }}>
                            Responded
                          </Typography>
                        ) : isUnresponsiveActive ? (
                          <Timer firebaseTime={rawArrivalTimestamp} />
                        ) : (
                          <Typography variant="body2" sx={{ color: "#94a3b8" }}>
                            Normal
                          </Typography>
                        )}
                      </MDBox>
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Actions</Typography>
                      <MDBox mt={0.5} display="flex" gap={1}>
                        <File props={escortData} />
                        <LongMenu props={{ ...displayData, id }} VitualWellBeingHomeCheck={false} />
                      </MDBox>
                    </Box>
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>

          {/* ── 3. Route & Destination Journey Timeline Card ── */}
          <Card
            sx={{
              mb: 3,
              p: 2.5,
              bgcolor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
            }}
          >
            <Grid container spacing={3} alignItems="center">
              {/* Pickup Point */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "10px",
                      bgcolor: "#dcfce7",
                      color: "#16a34a",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <PlaceRoundedIcon sx={{ fontSize: "1.3rem" }} />
                  </Box>
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#16a34a",
                        fontWeight: 800,
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                        fontSize: "0.72rem",
                      }}
                    >
                      Current Location · Live GPS
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#0f172a", fontWeight: 700, mt: 0.2 }}>
                      {currentLivePlaceName || pickupPlaceName || (pickupText && pickupText.toLowerCase() !== "current location" ? pickupText : "") || "Live Telemetry Active"}
                    </Typography>
                    {mapCenter && (
                      <Typography variant="caption" sx={{ color: "#64748b", fontSize: "0.72rem", display: "block", mt: 0.2 }}>
                        GPS: {mapCenter.lat.toFixed(4)}° N, {mapCenter.lng.toFixed(4)}° E
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>

              {/* Driving Directions Progress / Metrics */}
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      gap: 1,
                      mb: 0.8,
                    }}
                  >
                    <Box sx={{ flex: 1, height: "2px", bgcolor: "#cbd5e1" }} />
                    <Box
                      sx={{
                        px: 1.5,
                        py: 0.5,
                        bgcolor: "#f0f9ff",
                        border: "1px solid #bae6fd",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.6,
                      }}
                    >
                      <DirectionsCarRoundedIcon sx={{ fontSize: "1rem", color: "#0284c7" }} />
                      <Typography variant="caption" sx={{ fontWeight: 800, color: "#0284c7", fontSize: "0.75rem" }}>
                        {routeDistance || (destinationText ? "Direct Road Route" : "Live GPS Breadcrumbs")}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1, height: "2px", bgcolor: "#cbd5e1" }} />
                  </Box>

                  {routeDuration && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                      <AccessTimeRoundedIcon sx={{ fontSize: "0.95rem", color: "#16a34a" }} />
                      <Typography variant="caption" sx={{ fontWeight: 700, color: "#15803d" }}>
                        Estimated Driving Time: {routeDuration}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>

              {/* Destination Point */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, justifyContent: { xs: "flex-start", md: "flex-end" } }}>
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "10px",
                      bgcolor: destinationText ? "#fee2e2" : "#f1f5f9",
                      color: destinationText ? "#dc2626" : "#64748b",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <NavigationRoundedIcon sx={{ fontSize: "1.3rem" }} />
                  </Box>
                  <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: destinationText ? "#dc2626" : "#64748b",
                        fontWeight: 800,
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                        fontSize: "0.72rem",
                      }}
                    >
                      Destination / Delivery Point
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: destinationText ? "#0f172a" : "#64748b",
                        fontWeight: 700,
                        mt: 0.2,
                      }}
                    >
                      {destinationPlaceName || destinationText || "Local Escort · GPS Breadcrumbs Active"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Card>

          {/* ── 4. Custom Voice Deterrence Sender Card ── */}
          <Card
            sx={{
              mb: 3,
              p: 2,
              bgcolor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.2 }}>
              <RecordVoiceOverRoundedIcon sx={{ color: "#0284c7", fontSize: "1.2rem" }} />
              <Typography variant="subtitle2" fontWeight="700" sx={{ color: "#0f172a" }}>
                Send Voice Deterrence to Driver
              </Typography>
            </Box>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1.5, alignItems: "center" }}>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                value={customText}
                onChange={(e) => setCustomText(e.target.value)}
                placeholder="Type custom text to be read aloud inside the driver's device..."
                sx={{
                  bgcolor: "#f8fafc",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                }}
              />
              <Button
                variant="contained"
                onClick={handleSendCustomVoice}
                startIcon={<SendRoundedIcon />}
                sx={{
                  bgcolor: "#0284c7",
                  color: "#ffffff",
                  px: 3,
                  py: 1,
                  borderRadius: "8px",
                  fontWeight: 700,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  "&:hover": { bgcolor: "#0369a1" },
                }}
              >
                Send Voice
              </Button>
            </Box>
            {/* Quick action chips */}
            <Box sx={{ display: "flex", gap: 1, mt: 1.2, flexWrap: "wrap", alignItems: "center" }}>
              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Quick Messages:</Typography>
              {[
                "Please confirm your safety status.",
                "You have been stopped for over 2 minutes.",
                "Admin control room is monitoring your trip.",
              ].map((msg) => (
                <Chip
                  key={msg}
                  label={msg}
                  size="small"
                  onClick={() => setCustomText(msg)}
                  sx={{
                    fontSize: "0.72rem",
                    cursor: "pointer",
                    bgcolor: "#f1f5f9",
                    color: "#334155",
                    "&:hover": { bgcolor: "#e2e8f0" },
                  }}
                />
              ))}
            </Box>
          </Card>

          {/* ── 5. Google Map Card ── */}
          <Card
            sx={{
              borderRadius: "16px",
              overflow: "hidden",
              border: "1px solid #cbd5e1",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            }}
          >
            <GoogleMap
              mapContainerStyle={mapStyles}
              center={mapCenter}
              zoom={14}
              onLoad={(map) => setMapRef(map)}
            >
          {/* Driving Directions Road Route */}
          {directionsResponse && (
            <DirectionsRenderer
              directions={directionsResponse}
              options={{
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: "#0284c7",
                  strokeWeight: 6,
                  strokeOpacity: 0.85,
                },
              }}
            />
          )}

          {/* Current Live User / Driver Marker */}
          {mapCenter && (
            <Marker
              position={mapCenter}
              visible={true}
              title={`Live Location: ${displayData?.userName || "User"} (${isMovingStatus ? "Moving" : "Stopped"})`}
              label={{
                text: `📍 ${displayData?.userName || "User"} (Live)`,
                color: "#0f172a",
                fontWeight: "700",
                fontSize: "12px",
              }}
              onClick={() => handleMarkerClick({ ...mapCenter, title: `Live Location: ${displayData?.userName || "User"} · ${currentLivePlaceName || (isMovingStatus ? "Moving" : "Stopped")}` })}
              icon={
                window.google?.maps?.Size
                  ? {
                      url: mapicon,
                      scaledSize: new window.google.maps.Size(46, 46),
                      origin: new window.google.maps.Point(0, 0),
                      anchor: new window.google.maps.Point(23, 23),
                    }
                  : undefined
              }
            />
          )}

          {/* Destination Marker */}
          {destinationCoords && (
            <Marker
              position={destinationCoords}
              title={`Destination: ${destinationPlaceName || destinationText}`}
              label={{
                text: "🏁 Destination",
                color: "#b91c1c",
                fontWeight: "700",
                fontSize: "12px",
              }}
              onClick={() => handleMarkerClick({ ...destinationCoords, title: `Destination: ${destinationPlaceName || destinationText}` })}
              icon={
                window.google?.maps?.Size
                  ? {
                      url: "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2236%22%20height%3D%2236%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23dc2626%22%3E%3Cpath%20d%3D%22M12%202C8.13%202%205%205.13%205%209c0%205.25%207%2013%207%2013s7-7.75%207-13c0-3.87-3.13-7-7-7zm0%209.5c-1.38%200-2.5-1.12-2.5-2.5s1.12-2.5%202.5-2.5%202.5%201.12%202.5%202.5-1.12%202.5-2.5%202.5z%22%2F%3E%3C%2Fsvg%3E",
                      scaledSize: new window.google.maps.Size(38, 38),
                      anchor: new window.google.maps.Point(19, 36),
                    }
                  : undefined
              }
            />
          )}

          {/* Pickup / Origin Marker */}
          {pickupCoords && (
            <Marker
              position={pickupCoords}
              title={`Pickup: ${pickupPlaceName || pickupText}`}
              onClick={() => handleMarkerClick({ ...pickupCoords, title: `Pickup: ${pickupPlaceName || pickupText}` })}
              icon={
                window.google?.maps?.Size
                  ? {
                      url: "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2236%22%20height%3D%2236%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%2316a34a%22%3E%3Cpath%20d%3D%22M12%202C8.13%202%205%205.13%205%209c0%205.25%207%2013%207%2013s7-7.75%207-13c0-3.87-3.13-7-7-7zm0%209.5c-1.38%200-2.5-1.12-2.5-2.5s1.12-2.5%202.5-2.5%202.5%201.12%202.5%202.5-1.12%202.5-2.5%202.5z%22%2F%3E%3C%2Fsvg%3E",
                      scaledSize: new window.google.maps.Size(38, 38),
                      anchor: new window.google.maps.Point(19, 36),
                    }
                  : undefined
              }
            />
          )}

          {/* Connecting line to destination if road directions unavailable and distance is realistic (< 1500 km) */}
          {!directionsResponse && destinationCoords && mapCenter && (
            (() => {
              const dLat = (destinationCoords.lat - mapCenter.lat) * (Math.PI / 180);
              const dLng = (destinationCoords.lng - mapCenter.lng) * (Math.PI / 180);
              const a = Math.sin(dLat / 2) ** 2 + Math.cos(mapCenter.lat * (Math.PI / 180)) * Math.cos(destinationCoords.lat * (Math.PI / 180)) * Math.sin(dLng / 2) ** 2;
              const distKm = 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              if (distKm > 1500) return null;
              return (
                <Polyline
                  path={[mapCenter, destinationCoords]}
                  options={{
                    strokeColor: "#ef4444",
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    strokeDasharray: "6 6",
                  }}
                />
              );
            })()
          )}

          {/* User Route History */}
          {userLocation && userLocation.length > 1 && (
            <Polyline
              path={userLocation}
              options={{
                strokeColor: "#2563eb",
                strokeOpacity: 0.7,
                strokeWeight: 5,
              }}
            />
          )}

          {markerList.map((location) => (
            <Marker
              key={location.id}
              position={{ lat: location.lat, lng: location.lng }}
              title={location.title}
              onClick={() => handleMarkerClick(location)}
            />
          ))}

          {/* Saved Wellbeing Check Locations from user */}
          {Object.values(escortData?.videos || {})
            .filter(
              (v) =>
                (v?.type === "location" || v?.title === "Location Shared" || (!v?.videoUrl && !v?.audioUrl)) &&
                (v?.newCurrentLat != null || v?.latitude != null)
            )
            .map((loc, idx) => {
              const lat = Number(loc.newCurrentLat ?? loc.latitude);
              const lng = Number(loc.newCurrentLong ?? loc.longitude);
              if (isNaN(lat) || isNaN(lng)) return null;
              const timeStr = loc.createdAt || loc.timestamp
                ? new Date(loc.createdAt || loc.timestamp).toLocaleTimeString()
                : "";
              return (
                <Marker
                  key={`saved_loc_${idx}`}
                  position={{ lat, lng }}
                  title={loc.title || "Wellbeing Location Shared"}
                  onClick={() =>
                    setSelectedMarker({
                      lat,
                      lng,
                      title: `📍 Shared Location (${timeStr || "Wellbeing Response"})`,
                    })
                  }
                  icon={{
                    url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                  }}
                />
              );
            })}

          {selectedMarker && (
            <InfoWindow
              position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
              onCloseClick={() => setSelectedMarker(null)}
            >
              <div style={{ padding: "4px 8px" }}>
                <h4 style={{ margin: 0, fontSize: "0.9rem", color: "#0f172a" }}>{selectedMarker.title}</h4>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </Card>
    </MDBox>
  </DashboardLayout>
</>
  );
};

export default React.memo(ShortDistanceEscort);
